import { lazy } from "react";
import type { Modul, Zaehlerwert } from "../../kern/modul";
import { heute } from "../../kern/zeit";
import { useSitzungstermine } from "./daten";

// Erst laden, wenn jemand die Seiten öffnet (BAUPLAN-PAKETE.md, Abschnitt 5.7). Der Zähler „heute“ braucht nur die Daten.
const Sitzung = lazy(() => import("./Sitzung").then((m) => ({ default: m.Sitzung })));
const Protokolle = lazy(() => import("./Protokolle").then((m) => ({ default: m.Protokolle })));
const ProtokollDetail = lazy(() => import("./Protokolle").then((m) => ({ default: m.ProtokollDetail })));
const Ablage = lazy(() => import("./Ablage").then((m) => ({ default: m.Ablage })));

/** Zähler in der Navigation: „heute“, wenn heute eine Sitzung ist (BAUPLAN-ABSCHLUSS.md, Abschnitt 4.4) */
function useZaehlerSitzung(): Zaehlerwert | null {
  const termine = useSitzungstermine();
  const tag = heute();
  const heuteEine = (termine.data ?? []).some((t) => t.datum === tag && t.status !== "abgesagt");
  return heuteEine ? { wert: "heute", vorlesen: "heute ist Sitzung" } : null;
}

/** „Sitzungen“ fasst Nächste, Termine (Modul termine) und Protokolle zu einem Eintrag mit Reitern zusammen (BAUPLAN-PAKETE.md, 5.2).
 *  Mitglieder sehen die freigegebenen Protokolle unter „Verein“ (5.6). */
export const sitzung: Modul = {
  id: "sitzung",
  name: "Sitzung",
  routen: [
    { pfad: "/sitzung", seite: Sitzung, recht: "sitzung.leiten" },
    // Ohne Recht: Die Seite zeigt Mitgliedern nur die freigegebenen, die Policy lässt ihnen nichts anderes
    { pfad: "/protokolle", seite: Protokolle },
    { pfad: "/protokolle/:id", seite: ProtokollDetail },
    { pfad: "/ablage", seite: Ablage, recht: "ablage.lesen" },
  ],
  navigation: [
    { bereich: "vorstand", gruppe: "Sitzungen", label: "Nächste", pfad: "/sitzung", icon: "sitzung", recht: "sitzung.leiten", reihenfolge: 5, zaehler: useZaehlerSitzung },
    { bereich: "vorstand", gruppe: "Sitzungen", label: "Protokolle", pfad: "/protokolle", icon: "protokolle", recht: "protokolle.lesen", reihenfolge: 7 },
    { bereich: "verein", label: "Protokolle", pfad: "/protokolle", icon: "protokolle", ohneRecht: "protokolle.lesen", reihenfolge: 10 },
    { bereich: "vorstand", label: "Ablage", pfad: "/ablage", icon: "ablage", recht: "ablage.lesen", reihenfolge: 30 },
  ],
  ereignisse: [
    "sitzung.vorbereitet",
    "sitzung.gestartet",
    "sitzung.abgeschlossen",
    "sitzung.protokoll_angelegt",
    "sitzung.protokoll_bearbeitet",
    "sitzung.protokoll_freigegeben",
    "sitzung.protokoll_zurueckgezogen",
  ],
};
